module.exports = __webpack_public_path__ + "static/media/Img-07.ed7cdcb2.jpg";